module.exports = __webpack_public_path__ + "cb482a5255cf2af7a4bd1370ef66b5b1.jpg";